// extracted by mini-css-extract-plugin
export var container = "_6l-0";